import { useTheme } from "@/theme/ThemeProvider";
import { Text, View, type ViewStyle } from "react-native";

/**
 * Flache Sektion ohne Kasten – für Nebenbereiche in der Tierakte
 * (Finder, Beziehungen), die nicht wie Formular-Cards wirken sollen.
 */
export function SoftSection({
  title,
  action,
  headerRight,
  children,
  style,
}: {
  title: string;
  /** Rechte Aktion in der Leiste. `headerRight` bleibt für bestehende Aufrufe. */
  action?: React.ReactNode;
  headerRight?: React.ReactNode;
  children: React.ReactNode;
  style?: ViewStyle;
}) {
  const right = action ?? headerRight;
  const { theme } = useTheme();
  return (
    <View style={[{ gap: theme.space.sm }, style]}>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          gap: theme.space.sm,
          paddingBottom: theme.space.xs,
          borderBottomWidth: 1,
          borderBottomColor: theme.color.border,
        }}
      >
        <Text
          style={{
            color: theme.color.muted,
            fontSize: theme.fontSize.tiny,
            fontWeight: "700",
            letterSpacing: 0.5,
            textTransform: "uppercase",
            flex: 1,
          }}
          numberOfLines={1}
        >
          {title}
        </Text>
        {right ? <View style={{ flexShrink: 0 }}>{right}</View> : null}
      </View>
      {children}
    </View>
  );
}
